import { Reducer } from 'redux';
import { AutodeskActionTypes, AutodeskState } from './types';

const initialState: AutodeskState = {};

const reducer: Reducer<AutodeskState> = (state = initialState, action: any) => {
  switch (action.type) {
    case AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_START: {
      return {
        ...state,
        loadingTokenError: undefined,
        loadingToken: true
      };
    }
    case AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_SUCCESS: {
      return {
        ...state,
        loadingToken: false,
        authInfo: action.payload
      };
    }
    case AutodeskActionTypes.GET_AUTODESK_ACCESS_TOKEN_FAILURE: {
      return {
        ...state,
        loadingToken: false,
        loadingTokenError: action.payload
      };
    }
    case AutodeskActionTypes.GET_AUTODESK_FILE_START: {
      return {
        ...state,
        loadingFileError: undefined,
        loadingFile: true
      };
    }
    case AutodeskActionTypes.GET_AUTODESK_FILE_SUCCESS: {
      return {
        ...state,
        loadingFile: false,
        file: action.payload
      };
    }
    case AutodeskActionTypes.GET_AUTODESK_FILE_FAILURE: {
      return {
        ...state,
        loadingFile: false,
        loadingFileError: action.payload
      };
    }
    case AutodeskActionTypes.ADD_SAME_AUTODESK_FILE_LOADED: {
      return {
        ...state,
        sameFileLoaded: state.sameFileLoaded ? state.sameFileLoaded + 1 : 1
      };
    }
    case AutodeskActionTypes.RESET_AUTODESK: {
      const sameFileLoaded = state.sameFileLoaded
        ? state.sameFileLoaded - 1
        : 0;
      if (sameFileLoaded > 0) {
        return {
          ...state,
          sameFileLoaded
        };
      }
      return initialState;
    }
    default:
      return state;
  }
};

export { reducer as AutodeskReducer };
